export default "__VITE_ASSET__fkstbqOe__"